// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore"; // ✅ Add Firestore

const firebaseConfig = {
  apiKey: "AIzaSyArNc2jMLLeE7Wr_tuTQx2qPzpfSo4H7pU",
  authDomain: "reals-automated-3a8b7.firebaseapp.com",
  projectId: "reals-automated-3a8b7",
  storageBucket: "reals-automated-3a8b7.firebasestorage.app", // ✅ Fixed here
  messagingSenderId: "579926378671",
  appId: "1:579926378671:web:dbc79f4e7eea71ca332c5a",
  measurementId: "G-5W831KF53B"
};

// ✅ Initialize Firebase
const app = initializeApp(firebaseConfig);

// ✅ Auth
const auth = getAuth(app);

// ✅ Firestore
const db = getFirestore(app);

export { app, auth, db }; // ✅ Export db as well
